<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备类型" prop="devClassCode">
              <j-dict-select-tag dictCode placeholder="请选择设备类型" type="list" v-model="model.devClassCode" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备型号" prop="devModelId">
              <j-dict-select-tag dictCode placeholder="请选择设备型号" type="list" v-model="model.devModelId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="控制命令" prop="command">
              <a-input placeholder="请输入控制命令" v-model="model.command"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="控制命令名称" prop="commandName">
              <a-input placeholder="请输入控制命令名称" v-model="model.commandName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="禁用" prop="disabled">
              <j-switch v-model="model.disabled"></j-switch>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs @change="handleChangeTabs" v-model="activeKey">
      <a-tab-pane :forceRender="true" :key="refKeys[0]" tab="智能加水机控制命令参数">
        <j-editable-table
          :actionButton="true"
          :columns="wfDevControlCmdparamTable.columns"
          :dataSource="wfDevControlCmdparamTable.dataSource"
          :disabled="formDisabled"
          :loading="wfDevControlCmdparamTable.loading"
          :maxHeight="300"
          :ref="refKeys[0]"
          :rowNumber="true"
          :rowSelection="true"
        />
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import { getAction } from '@/api/manage'
  import { FormTypes, getRefPromise, VALIDATE_NO_PASSED } from '@/utils/JEditableTableUtil'
  import { JEditableTableModelMixin } from '@/mixins/JEditableTableModelMixin'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'WfDevControlCmdForm',
    mixins: [JEditableTableModelMixin],
    components: {
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        model: {
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
          command: [
            { required: true, message: '请输入控制命令!' },
          ],
          commandName: [
            { required: true, message: '请输入控制命令名称!' },
          ],
        },
        refKeys: ['wfDevControlCmdparam',],
        tableKeys: ['wfDevControlCmdparam',],
        activeKey: 'wfDevControlCmdparam',
        // 智能加水机控制命令参数
        wfDevControlCmdparamTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '控制命令',
              key: 'cmdId',
              type: FormTypes.select,
              dictCode: "wf_dev_control_cmd,command_name,id",
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: '参数名称',
              key: 'paramName',
              type: FormTypes.input,
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: '参数值',
              key: 'paramValue',
              type: FormTypes.input,
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
          ]
        },
        url: {
          add: "/wf/controlCmd/add",
          edit: "/wf/controlCmd/edit",
          queryById: "/wf/controlCmd/queryById",
          wfDevControlCmdparam: {
            list: '/wf/controlCmd/queryWfDevControlCmdparamByMainId'
          },
        }
      }
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
    },
    methods: {
      addBefore () {
        this.wfDevControlCmdparamTable.dataSource = []
      },
      getAllTable () {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter () {
        this.$nextTick(() => {
        })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.wfDevControlCmdparam.list, params, this.wfDevControlCmdparamTable)
        }
      },
      //校验所有一对一子表表单
      validateSubForm (allValues) {
        return new Promise((resolve, reject) => {
          Promise.all([
          ]).then(() => {
            resolve(allValues)
          }).catch(e => {
            if (e.error === VALIDATE_NO_PASSED) {
              // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
              this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
            } else {
              console.error(e)
            }
          })
        })
      },
      /** 整理成formData */
      classifyIntoFormData (allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          wfDevControlCmdparamList: allValues.tablesValue[0].values,
        }
      },
      validateError (msg) {
        this.$message.error(msg)
      },

    }
  }
</script>

<style scoped>


</style>